import { registerComponent } from "helpers";

registerComponent(
  "wyatt-message",
  class WyattMessage extends HTMLElement {
    constructor() {
      super();

      this.dismissButton = this.querySelector("[data-dismiss]");

      this.dismissButton.addEventListener(
        "click",
        this.handleDismissClick.bind(this),
      );
    }

    handleDismissClick(event) {
      event.preventDefault();
      event.stopPropagation();

      this.dismiss();
    }

    dismiss() {
      this.setAttribute("removing", true);
      this.addEventListener("transitionend", () => this.remove());
    }
  },
);
